import React, { FC, ReactNode, useId } from 'react';
import styled from 'styled-components';
import breakpoints from '../../../design-system/breakpoints';
import Variables from '../../../design-system/variables';

interface OvRecordDetailsSectionProps {
  title: ReactNode;
  action?: ReactNode;
  children: ReactNode;
}

const OvRecordDetailsSection: FC<OvRecordDetailsSectionProps> = ({
  title,
  action = null,
  children,
}) => {
  const titleId = useId();

  return (
    <Section aria-labelledby={titleId}>
      <SectionHeader>
        <Title id={titleId}>{title}</Title>
        {action}
      </SectionHeader>
      {children}
    </Section>
  );
};

export default OvRecordDetailsSection;

const Section = styled.section`
  min-width: 0;
  padding: 1.25rem 1.5rem;
  font-size: ${Variables.fontSizes.MEDIUM};

  @media (max-width: ${breakpoints.lg}) {
    padding: 1.125rem 1.25rem;
  }
`;

const SectionHeader = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  margin-bottom: 0.875rem;
`;

const Title = styled.h2`
  margin: 0;
  font-size: ${Variables.fontSizes.LARGE};
  line-height: ${Variables.lineHeights.MLARGE};
`;
